import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-config-main" },
    [
      _c(
        VLayout,
        { attrs: { row: "", wrap: "", "mx-0": "" } },
        [
          _c(
            VFlex,
            { staticClass: "pr-md-4", attrs: { xs12: "", md6: "" } },
            [
              _c("h2", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("reporting.config.goLiveWorkpackages"))),
              ]),
              _vm._v(" "),
              _c("workpackage-selector", {
                attrs: { "max-selections": _vm.maxWorkpackageSelections },
                on: { "menu-closed": _vm.onWpMenuClosed },
                model: {
                  value: _vm.selectedWorkpackages,
                  callback: function ($$v) {
                    _vm.selectedWorkpackages = $$v
                  },
                  expression: "selectedWorkpackages",
                },
              }),
              _vm._v(" "),
              _vm.hasOverlappingPricingGroups
                ? _c(
                    VAlert,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        value: true,
                        color: "error",
                        icon: "warning",
                        outlined: "",
                      },
                    },
                    _vm._l(_vm.overlappingPricingGroups, function (pg, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "overlap-error" },
                        [
                          _vm._v(
                            '\n          "' +
                              _vm._s(pg.pricingGroupName) +
                              '"\n          ' +
                              _vm._s(
                                _vm.$t(
                                  "reporting.config.pricingGroupOverlapMessage"
                                )
                              ) +
                              "\n          (\n          "
                          ),
                          _vm._l(
                            pg.workpackageNames,
                            function (wpName, wpIndex) {
                              return [
                                _c(
                                  "a",
                                  {
                                    key: pg.workpackageIds[wpIndex],
                                    staticClass: "overlap-wp-link",
                                    attrs: {
                                      href: _vm.getWorkpackageUrl(
                                        pg.workpackageIds[wpIndex]
                                      ),
                                      target: "_blank",
                                    },
                                  },
                                  [_c("strong", [_vm._v(_vm._s(wpName))])]
                                ),
                                _vm._v(" "),
                                wpIndex < pg.workpackageNames.length - 1
                                  ? _c("span", { key: "sep-" + wpIndex }, [
                                      _vm._v("\n              ,\n            "),
                                    ])
                                  : _vm._e(),
                              ]
                            }
                          ),
                          _vm._v("\n          )\n        "),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasMatchingPricingGroups &&
              _vm.approvalStatus &&
              _vm.selectedWorkpackageIds.length > 0
                ? _c(
                    VAlert,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        value: true,
                        color: "warning",
                        icon: "info",
                        outlined: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.approvalStatus === "approved"
                              ? _vm.$t(
                                  "reporting.config.noApprovedPricingGroups"
                                )
                              : _vm.$t(
                                  "reporting.config.noNotApprovedPricingGroups"
                                )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VFlex,
            { staticClass: "pl-md-4", attrs: { xs12: "", md6: "" } },
            [
              _c("h2", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("reporting.config.keyAttributes"))),
              ]),
              _vm._v(" "),
              _c("attribute-selector", {
                ref: "attributeSelector",
                attrs: {
                  "available-attributes": _vm.hasWorkpackagesSelected
                    ? _vm.availableAttributes
                    : [],
                  "max-selections": _vm.maxAttributeSelections,
                  "max-values": _vm.maxAttributeValueLimit,
                  loading: _vm.loading,
                },
                model: {
                  value: _vm.selectedAttributes,
                  callback: function ($$v) {
                    _vm.selectedAttributes = $$v
                  },
                  expression: "selectedAttributes",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c("h2", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(_vm.$t("reporting.config.approvalStatus"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    VRadioGroup,
                    {
                      model: {
                        value: _vm.approvalStatus,
                        callback: function ($$v) {
                          _vm.approvalStatus = $$v
                        },
                        expression: "approvalStatus",
                      },
                    },
                    [
                      _c(VRadio, {
                        attrs: {
                          label: _vm.$t("reporting.config.approvedAndReleased"),
                          value: "approved",
                        },
                      }),
                      _vm._v(" "),
                      _c(VRadio, {
                        attrs: {
                          label: _vm.$t("reporting.config.notApproved"),
                          value: "notApproved",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-6 d-flex" },
        [
          _c(VSpacer),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "reporting-action-btn",
              attrs: { text: "" },
              on: { click: _vm.cancel },
            },
            [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "ml-2 reporting-action-btn",
              attrs: { color: "primary", disabled: !_vm.canGenerateReport },
              on: { click: _vm.generateReport },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("reporting.config.generateReport")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }